import React, { Component } from "react";
import { BsTwitter, BsInstagram } from "react-icons/bs";
import { ImFacebook, ImLinkedin2 } from "react-icons/im";
import styles from "./NewFooter.module.css";
import axios from "axios"; // Import axios
import Swal from "sweetalert2"; // Import Swal

const playStoreUrl = "https://play.google.com/store/apps/details?id=com.goodlives.wellness&hl=en_IN";
const appStoreUrl = "https://apps.apple.com/in/app/goodlives/id6740541252";
const instagramUrl = "https://www.instagram.com/goodlives.insta/?hl=en";
const linkedinUrl = "https://in.linkedin.com/company/goodlives";
const facebookUrl = "https://www.facebook.com/goodlives.in"; // Added Facebook URL
const twitterUrl = "https://twitter.com/GoodLives4"; // Added Twitter URL

export class NewFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "", // Added email state for the newsletter input
      emailError: false, // State to manage email validation error
      // subscribeMessage: "", // State for displaying messages (optional, Swal is used here)
    };
  }

  handleNewsletterSubscribe = async (event) => {
    if (event) event.preventDefault(); // Good practice if this button were ever in a form

    const { email } = this.state;
    let regexEmail =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (
      email.trim() === "" ||
      !regexEmail.test(email) ||
      // Consider if these domain checks are necessary for a general newsletter
      email.includes("@gmail.com") ||
      email.includes("@outlook.com") ||
      email.includes("@hotmail.com") ||
      email.includes("@yahoo.com")
    ) {
      this.setState({ emailError: true });
      Swal.fire({ // Using Swal for error feedback as in scheduleDemo
        icon: "error",
        title: "Invalid Email",
        text: "Please enter a valid work email address.",
      });
      return false;
    }
    this.setState({ emailError: false });

    try {
      let data = { email: email };
      await axios.post(process.env.REACT_APP_SERVER_URI + "/api/emailForNewsLetter", data);
      Swal.fire("Subscribed!", "You've successfully subscribed to our newsletter.", "success");
      this.setState({ email: "" });
    } catch (err) {
      Swal.fire("Oops...", err.response?.data?.error || "Something went wrong!", "error");
    }
  };

  render() {
    const { email, emailError } = this.state;
    return (
      <div className={styles["footer-Container"]}>
        <div className={styles.footerContent}>
          <div className={styles.leftSection}>
            <h3>You are worthy of Happiness & Peace of Mind</h3>
            <p>You are worthy of Happiness & Peace of Mind</p>
            <div className={styles.storeButtons}>
              <button onClick={()=> window.open(playStoreUrl, '_blank')} style={{backgroundColor: 'transparent', borderWidth: 0}}>
              <img
                className={styles.fCgooglePlaybtn}
                src="https://ucarecdn.com/54255551-f668-4f7e-9be4-49711eb9737f/playStoreBtn.svg"
                alt="play store"
              />
              </button>
              <button onClick={()=> window.open(appStoreUrl, '_blank')} style={{backgroundColor: 'transparent', borderWidth: 0}}>
              <img
                className={styles.fCappStorebtn}
                src="https://ucarecdn.com/401ca259-8c68-474c-9529-f4ed6d5f9050/appStoreBtn.svg"
                alt="app store"
              />
              </button>
            </div>
          </div>

          <div className={styles.rightSection}>
            <div className={styles.centerSection}>
              <h4>Info</h4>
              <div className={styles.infoLinks}>
                <div className={styles.linkRow}>
                  <span><a href="/about-us">About Us</a></span>
                  <span><a href="https://www.goodlives.in/faq/">FAQ</a></span>
                </div>
                <div className={styles.linkRow}>
                  <span><a href="https://www.goodlives.in/privacy-policy/">Privacy Policy</a></span>
                  <span><a href="https://goodlives.in/blog/">Blogs</a></span>
                </div>
              </div>
            </div>

            <h4>Subscribe to Our Newsletter</h4>
            <div className={styles.subscribeForm}>
              <input
                type="email"
                placeholder="Enter Email"
                value={email}
                onChange={(e) => this.setState({ email: e.target.value, emailError: false })}
                className={emailError ? styles.inputError : ""}
              />
              <button onClick={this.handleNewsletterSubscribe}>Subscribe</button>
            </div>
            <div className={styles.socialIcons}>
              <div onClick={() => window.open(facebookUrl, '_blank')} style={{cursor: 'pointer'}}>
                <ImFacebook />
              </div>
              <div onClick={() => window.open(twitterUrl, '_blank')} style={{cursor: 'pointer'}}>
                <BsTwitter />
              </div>
              <div onClick={() => window.open(linkedinUrl, '_blank')} style={{cursor: 'pointer'}}>
                <ImLinkedin2 />
              </div>
              <div onClick={() => window.open(instagramUrl, '_blank')} style={{cursor: 'pointer'}}>
                <BsInstagram />
              </div>
            </div>
          </div>
        </div>

        <div className={styles.copyright}>
          <hr />
          <p>© Copyright 2025 | GoodLives</p>
        </div>
      </div>
    );
  }
}

export default NewFooter;
